
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 15a6.007 6.007 0 016-6h4.998c.065 0 6.547-.086 12.716-5.26A2 2 0 0129 5.27v19.46a1.98 1.98 0 01-1.154 1.811 1.989 1.989 0 01-2.133-.28C20.98 22.287 16.06 21.314 14 21.076v4.388a1.995 1.995 0 01-.89 1.664l-1.375.916a2 2 0 01-3.05-1.18l-1.48-5.92A6.008 6.008 0 012 15zm8.626 11.38L12 25.466V21H9.28l1.346 5.38zM8 19h4v-8H8a4 4 0 000 8z","fill":"#3F51B5"}})])
          )
        }
      }
    